module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "txc",
    attrs: {
      "id": "d6e193"
    }
  }, [_c('b', [_vm._v("Also by the author")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "d6e243"
    }
  }, [_c('i', [_vm._v("Death of a Nationalist ")]), _c('br'), _c('i', [_vm._v("Law of Return ")]), _c('br'), _c('i', [_vm._v("The Watcher in the Pine ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34a65682","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pawe_9781569477786_epub_c3_r1.vue
// module id = 63
// module chunks = 0